export const { format: formatDate } = new Intl.DateTimeFormat('pt-BR');


export function formatDateYYYYMMDD(value: string) {
    if (!value)
        return;

    if (value.indexOf('-') >= 0) {
        const array = value.split(/\s/)[0].split('-');
        value = array[2] + "/" + array[1] + "/" + array[0]
    }

    const arrayDate = value.split(/\s/)[0].split('/');

    var data = new Intl.DateTimeFormat('fr-ca')
        .format(new Date(Number(arrayDate[2]), Number(arrayDate[1]) - 1, Number(arrayDate[0])));

    return data;
}